<template>
  <block
    component-name="block-form-support-picker"
    body-class="flex flex-col items-stretch gap-3xl"
  >
    <form-web-to-lead-picker scope="page" />
  </block>
</template>
